var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.855713,
    y: 0.673828,
    width: 26.2887,
    height: 28.0899,
    fill: "url(#pattern0_110_370)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_110_370",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_110_370",
    transform: "matrix(0.0111111 0 0 0.0103986 0 0.0320619)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_110_370",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC4klEQVR4nO2aTahNURiGFwZKCplRuKQMZcRUdywjfyPJRK6BFGVgwEgyMVEm6ioz+S0jQxIuuZNbCinXRWHmNx6tY+8Z1zrf2t9eZ9/zPnU6g1Pf937v3vs9a+29QxBCCCGEEEKIuQgwH9gD3ATeAN+q7xvA7vh7aY2dB1gHPGZ2JoCR0lq7bvJ70ngns20mLwCe0B8PFSP9Gx0z2cJOy4EdWoBbRqOvl9beKYAZo9HTpbV3imoJZ+Frae2dolonW3hdWnunqDYjFq6W1t4pgF1Go3eU1t7FbXfc8fXDA62jbWaPVDu+FN4Cq5s/5MNl9qOEM3lNaa1zJUZiZl+P6+Rq6Re/r8WdoOJCCCGEGOx76suBtdVnGbCwtK7Owx8j9wOXgWfAr78sRX8Cr4A7wClgNB6QkqLNBL/6U/+otR64FO8cGutOV6YvbdxIJyN6tGV0jAHgNPCDZvgA7HUztUEjerRhNLDC8EwzlQutxUmOyuBsNLAKeIkvF91NzjCih2P9KWAx8JR2GBtmo8/RHl/cb5blqAt+9b9Xy7M2GR9Go0sQD+5KGd0Ox2R0O9yT0e0Q/xeWKKPpvVx5FNgObAE2AlvjJQ9MNmT26DAb/RzYnPAY7kDGm1c1hxoztykjgnP9isl+LmdgX2a/s1mGehgRnOsDn4ENfc4zD7ib0fOK2UwvI4Jz/XjTxzjTtoyeE5aeKaLMBOf6wCbjTIuqq8HCC0vPFFFmgm/9jznvkQD3jX1nrD3/J8hM8K1/O3OucWPfTzl9ZxNkJvjWP58515mBesF+gI0+kTnXSc+5LILMBN/6RzLnOu45l0WQmeBbP2uHBhz2nMsiyEzwrX8wc64xz7ksgswE3/oyukZG64wOio50FB01ig5FR1B0pKPoqFF0KDqCoiMdRUeNokPRERQd6Sg6ahQdio6g6EhH0VGj6FB0BEVHOoqOGkWHoiMMXHQIIYQQQgghhBBCCCFEmFP8BsqRFeE8vQqMAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.5ba13a7f6c52491c5ab322bc00310f6a.svg";
export { ForwardRef as ReactComponent };